var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9386 5.05246C12.8833 5.0435 12.8274 5.03936 12.7715 5.04009H3.24752L3.45519 4.9435C3.65819 4.84742 3.84286 4.71666 4.00094 4.55713L6.6717 1.88637C7.02345 1.55059 7.08255 1.01043 6.81176 0.606525C6.4966 0.176118 5.89221 0.0826657 5.46177 0.397827C5.427 0.423303 5.39394 0.451073 5.36288 0.480956L0.533293 5.31055C0.155861 5.68756 0.155529 6.29913 0.532539 6.67656C0.53278 6.67681 0.533052 6.67708 0.533293 6.67732L5.36288 11.5069C5.74062 11.8836 6.35219 11.8827 6.7289 11.505C6.75854 11.4753 6.78622 11.4436 6.81176 11.4103C7.08255 11.0064 7.02345 10.4663 6.6717 10.1305L4.00577 7.45488C3.86405 7.31301 3.70111 7.19406 3.52281 7.10232L3.23303 6.97192H12.7183C13.2118 6.99025 13.6447 6.64556 13.7374 6.16055C13.8228 5.63398 13.4652 5.13789 12.9386 5.05246Z",
    fill: "#1D4469"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackIcon);
export default __webpack_public_path__ + "static/media/BackIcon.f00aa20ee5a51fc371ce58fbf388f206.svg";
export { ForwardRef as ReactComponent };